module.exports = {}
//module.exports.Blue = "#117DB3";

//module.exports.LightBlue = "#98CDE9";
module.exports.Blue = "#3c9cd7";
module.exports.LightBlue = "#a2d5f5";
module.exports.Gray = "#F3F3F3"
module.exports.ColorReadable = "#1973B3"
